export function round(num: number, precision = 2) {
	const multiplier = 10 ** precision;
	return Math.round((num + Number.EPSILON) * multiplier) / multiplier;
}

export function percentageDifference(
	a: number,
	b: number,
	precision = 2,
): number {
	if (b === 0) {
		return Number.POSITIVE_INFINITY;
	}

	return round(((a - b) / b) * 100, precision);
}
